import type { SortableCollectionListBaseProps } from '@/components/blocks/editor/collection/collection-dnd';
import type { CollectionMediaLayout } from '@/lib/blocks/collection/media-layout';
import { SortableAlternatingCard } from './alternating-card';

interface SortableAlternatingListProps extends SortableCollectionListBaseProps {
  containerClassName: string;
  mediaLayout: CollectionMediaLayout;
}

export function SortableAlternatingList({
  items,
  cardConfig,
  cardPaddingClass,
  cardStyle,
  containerClassName,
  mediaLayout,
  collectionSortableGroup,
  collectionItemDragData,
  disabled,
  actionsDisabled,
  selectedItemId,
  onUpdate,
  onDelete,
  onDuplicate,
  onSelectionChange,
}: SortableAlternatingListProps) {
  return (
    <div className={containerClassName}>
      {items.map((item, index) => (
        <SortableAlternatingCard
          key={item.id}
          item={item}
          index={index}
          sortIndex={index}
          totalCount={items.length}
          cardConfig={cardConfig}
          mediaLayout={mediaLayout}
          paddingClassName={cardPaddingClass}
          cardStyle={cardStyle}
          collectionSortableGroup={collectionSortableGroup}
          collectionItemDragData={collectionItemDragData}
          disabled={disabled}
          actionsDisabled={actionsDisabled}
          onUpdate={onUpdate}
          onDelete={() => onDelete(item.id)}
          onDuplicate={() => onDuplicate(item.id)}
          primarySelected={selectedItemId === item.id}
          onSelectionChange={(selected) => onSelectionChange(item.id, selected)}
        />
      ))}
    </div>
  );
}
